import { Injectable, NgZone } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class ConnectionStateService {
  private approvedSubject = new BehaviorSubject<boolean>(false);
  approved$: Observable<boolean> = this.approvedSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  setApproved(value: boolean) {
    // Ensure change happens inside Angular zone (covers BLE/native callbacks)
    this.ngZone.run(() => {
      // console.log('[ConnectionStateService] setApproved:', value);
      this.approvedSubject.next(value);
    });
  }

  get isApproved(): boolean {
    return this.approvedSubject.value;
  }
}
